/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { Link } from '../common';
import LocalizationContext from '../../contexts/Localizations';
import CompetitionCard from '../CompetitionCard';
import Carousel from '../Carousel';
import CompetitionCarouselProps from './type';
import './styles.scss';

const CompetitionCarousel = ({
  cards,
  competitions,
  themeColor,
  slickConfig,
  standalone,
  viewMoreLink,
  title,
}: CompetitionCarouselProps) => {
  const { translations } = useContext(LocalizationContext);

  return (
    <div className={`competition-carousel competition-carousel--${themeColor} ${standalone ? 'competition-carousel--standalone' : ''}`}>
      {title && (
        <h2 className="competition-carousel__title">
          {title}
        </h2>
      )}

      <div className="competition-carousel__container">
        <Carousel
          containerTheme={themeColor}
          slickConfig={slickConfig}
          viewMoreLink={viewMoreLink}
        >
          {cards?.live?.map((item, index) => (
            <div key={index} className="competition-carousel__slide">
              <CompetitionCard
                {...item}
                label={index === 0 ? translations.calendar.liveLabel : ''}
                isLive={index === 0}
              />
            </div>
          ))}

          {cards?.latest?.map((item, index) => (
            <div key={index} className="competition-carousel__slide competition-carousel__slide--latest">
              <CompetitionCard
                {...item}
                label={index === 0 ? translations.calendar.latestLabel : ''}
              />
            </div>
          ))}

          {cards?.upcoming?.map((item, index) => (
            <div key={index} className="competition-carousel__slide">
              <CompetitionCard
                {...item}
                label={index === 0 ? translations.calendar.upcomingLabel : ''}
              />
            </div>
          ))}

          {competitions?.map((item, index) => (
            <div key={index} className="competition-carousel__slide">
              <CompetitionCard {...item} />
            </div>
          ))}
        </Carousel>
      </div>
      {viewMoreLink && (
        <div className="competition-carousel__link--mobile">
          <Link
            {...viewMoreLink}
            iconAfter={{ reference: '#icon-think-arrow', title: viewMoreLink.title }}
            aria-label={viewMoreLink.title}
          />
        </div>
      )}
    </div>
  );
};

export default CompetitionCarousel;
